import { z } from 'zod';
import type { DigitalMenuBasketLine } from './digital-menu.utils';

const MAX_QR_LENGTH = 2000;
const positiveId = z.number().int().positive().safe();
const basketQrSchema = z.object({
  v: z.literal(1),
  t: z.string().min(1).max(120),
  i: z.array(z.tuple([positiveId, z.number().int().min(1).max(99), z.array(positiveId).max(200)])).min(1).max(50),
}).strict();

export function encodeBasketQr(tenantId: string, lines: DigitalMenuBasketLine[]): string {
  const payload = basketQrSchema.parse({ v: 1, t: tenantId, i: lines.map((line) => [line.productId, line.quantity, line.picks]) });
  const text = JSON.stringify(payload);
  if (new Blob([text]).size > MAX_QR_LENGTH) throw new Error('הסל גדול מדי לקוד אחד');
  return text;
}

export function decodeBasketQr(text: string, tenantId: string) {
  if (text.length > MAX_QR_LENGTH) throw new Error('קוד הסל אינו תקין');
  const result = basketQrSchema.safeParse(JSON.parse(text));
  if (!result.success) throw new Error('קוד הסל אינו תקין');
  if (result.data.t !== tenantId) throw new Error('הסל שייך למסעדה אחרת');
  return result.data.i.map(([productId, quantity, picks]) => ({ productId, quantity, picks }));
}